/* istanbul ignore file */

import { updateDayjsLocale } from '@utilities/dateTime';
updateDayjsLocale();

import '@core/css-browser-selector';
import '@services/LazyloadService';

import '@core/app-insight';

import '@services/GoogleTagManagerService';

import '@services/LanguageService';
import '@core/plugin-loader';
import '@core/stylesheet-loader';
import '@core/react-loader';
import '@core/panenka-loader';

import '@services/GptBannerService';
import '@utilities/country';
import '@socials/TweetBook';
import '@services/QualifioTrackingService';

import '@core/simulators';
